export default "__VITE_ASSET__b02e062e__"